"use strict";
/**
|--------------------------------------------------
| Validate Forms Functions
|--------------------------------------------------
*/

export const validateFormBootstrap = (formClass) => {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    let forms = document.querySelectorAll(formClass)

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms).forEach(function (form) {
        form.setAttribute('novalidate', "");
        form.addEventListener('submit', function (event) {

            if (!form.checkValidity()) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                const recaptchaElement = form.querySelector('.g-recaptcha');
                if(recaptchaElement){
                    grecaptcha.execute();
                }
            }

            form.classList.add('was-validated');
        }, false);
    });
};